import * as api from  './api'
import { AppDispatch } from 'src/app/store'
import * as reducers from './slice-reducers'
import { FinalizePaypaPayloadlType } from 'src/core/models'

export const finalizePaypalPayment = (payload: FinalizePaypaPayloadlType) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setFinalizePaypalPaymentLoading(true))
    await api.finalizePaypalPaymentAPI(payload)
    dispatch(reducers.setFinalizePaypalPaymentSuccess(true))
    dispatch(reducers.setFinalizePaypalPaymentLoading(false))
  }catch (error){
    dispatch(reducers.setFinalizePaypalPaymentLoading(false))
    dispatch(reducers.setFinalizePaypalPaymentSuccess(false))
    dispatch(reducers.setFinalizePaypalPaymentError(error))
  }
}
